import { useQuery } from "@tanstack/react-query";
import { UseFormReturn, useWatch } from "react-hook-form";

import { loadMaterials } from "../core/material.core";
import { SortAsec, SortKey } from "../types/product";
import { MaterialListFilter } from "../types/material";

export default function useMaterialQuery(methods: UseFormReturn<MaterialListFilter, any>) {
  const [pageSize, search, categoryIds, page, sort, sortAsec] = useWatch({
    name: ["pageSize", "search", "categoryIds", "page", "sort", "sortAsec"],
    control: methods.control,
  });

  return useQuery({
    queryKey: ["materials", page, pageSize, search, categoryIds, sort, sortAsec],
    queryFn: (context) =>
      loadMaterials({
        paging: {
          page: context.queryKey[1] as number,
          size: context.queryKey[2] as number,
        },
        search: context.queryKey[3] as string,
        categoryIds: context.queryKey[4] as string[],
        sort: context.queryKey[5] as SortKey,
        sortAsec: context.queryKey[6] as SortAsec,
      }),
  });
}
